import { httpStatus } from './httpStatus'

export const constants = {
	httpStatus
}
